import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as WalkingSvg } from './assets/walking.svg';

const WalkingIcon = React.forwardRef((args, ref) => <SvgIcon component={WalkingSvg} ref={ref} {...args} />);

export default WalkingIcon;
